import { Link } from "react-router-dom";
import { BLOG_POSTS } from "../data/content";
import { Clock } from "lucide-react";

export default function Blog() {
  return (
    <div data-testid="blog-page" className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="eyebrow">Blog</div>
        <h1 className="font-display uppercase text-white text-4xl md:text-6xl mt-4 leading-[0.95] tracking-tight">
          Conseils <span className="text-[#7DD923]">rénovation</span> énergétique
        </h1>
        <p className="text-white/70 mt-4 max-w-2xl">
          Guides, actualités et conseils d'experts pour optimiser votre projet et vos aides.
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {BLOG_POSTS.map((p) => (
            <Link
              key={p.slug}
              to={`/blog/${p.slug}`}
              data-testid={`blog-card-${p.slug}`}
              className="group bg-[#121212] border border-white/5 rounded-2xl overflow-hidden hover:border-[#7DD923]/40 transition-colors"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6">
                <div className="text-xs uppercase tracking-widest text-[#7DD923] font-bold">{p.category}</div>
                <h3 className="font-display text-white text-xl mt-2 leading-tight tracking-tight group-hover:text-[#7DD923] transition-colors">{p.title}</h3>
                <p className="text-white/60 text-sm mt-3 leading-relaxed line-clamp-2">{p.excerpt}</p>
                <div className="text-white/40 text-xs mt-5 pt-4 border-t border-white/5 flex items-center justify-between">
                  <span>{p.date}</span>
                  <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {p.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
